import { FC } from 'react';
import { useClaimTime } from 'react-scale/hooks/useClaimTime';
import { Claim } from '@scale/shared/types/queue';
import { TaskHeader } from '@scale/scaleui';
import _ from 'lodash';

type InfoIdleTimeProps = {
  claim?: Claim;
  visible?: boolean;
};

export const InfoIdleTime: FC<InfoIdleTimeProps> = ({ claim, visible }) => {
  const { idleMinutes } = useClaimTime(claim);
  if (!claim) return null;

  const originalTaskDuration = idleMinutes;

  const idleTimeStr =
    originalTaskDuration > 120
      ? `${_.round(originalTaskDuration / 60, 1)} hours`
      : `${originalTaskDuration} ${originalTaskDuration > 1 ? 'minutes' : 'minute'}`;

  return (
    <TaskHeader.InfoHandlerItem visible={visible} title="Max Idle Time">
      {idleTimeStr}
    </TaskHeader.InfoHandlerItem>
  );
};
